<template>
  <div class="about">
    <div class="const-icon">
      <i class="pi pi-briefcase" ></i>
    </div>
    <div class="const-title">
      This part is still under construction
    </div>
  </div>
</template>
<style lang="scss">
.const-icon > i{
  font-size: 5em;
  color: #B00020;
}
.const-title {
  font-family: "Segoe UI Light", sans-serif;
  font-size: 3em;
}
.about{
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

</style>
